import React from "react";

const DionSixtyEighth = () => {
  return (
    <div className="flex flex-col font-bold text-justify p-4 sm:p-2 lg:p-1 xl:p-0 ">
      <p className="mt-3">
        A maioria dos homens em todas as suas buscas e interesses os segue em
        total ignorância sobre qual é a natureza de cada um ou mesmo qual é o
        valor prático de cada um; em vez disso, eles são atraídos por opinião,
        prazer ou hábito. Tampouco, por outro lado, no caso daquelas atividades
        e interesses dos quais eles se abstêm e nos quais evitam se envolver,
        eles se abstêm porque sabem quais são prejudiciais ou qual é a natureza
        do dano que acarretam; em vez disso, também nessas questões, tudo o que
        eles observam que seus vizinhos evitam ou coisas que se tornou seu
        costume evitar ou que eles supõem que serão desagradáveis para eles e
        têm a reputação de serem acompanhadas de alguma dor, essas coisas eles
        geralmente veem com desconfiança.
      </p>
      <p className="mt-3 ">
        Além disso, embora as sensações de prazer e de dor sejam comuns a todos
        os homens - embora alguns sejam escravizados por elas em menor grau e
        outros em maior grau - a questão de opinião varia e não é a mesma para
        todos. Assim acontece que alguns elogiam ou censuram isso e outros
        aquilo, muitas vezes agindo em desacordo a esse respeito. Por exemplo, a
        dor é experimentada tanto pelo indiano quanto pelo espartano quando são
        feridos ou queimados, assim como pelo frígio e pelo lídio; no entanto,
        enquanto o indiano e o espartano se recusam a fraquejar porque foram
        endurecidos para isso, o frígio e o lídio fraquejam porque são fracos e
        não endurecidos. Mais uma vez, embora o prazer seja inevitavelmente
        experimentado nas relações sexuais e na comida e na bebida que são
        prazerosas, não apenas pelos jônios, mas também pelos tessálios,{" "}
        <a
          href="https://pt.wikipedia.org/wiki/Magna_Gr%C3%A9cia"
          target="_blank"
          rel="noopener noreferrer"
          className="underline underline-offset-2 text-sky-300 hover:scale-100"
        >
          gregos italianos
        </a>
        , getanos, indianos e espartanos, ainda assim alguns não pensam em todos
        para tais gratificações e não procuram conhecer nenhum deles, enquanto
        os outros aceitariam a morte como preço para obter um pouco mais de
        prazer.{" "}
      </p>
      <p className="mt-3 ">
        Agora, aparentemente, a questão da opinião é de todo tipo concebível e
        as diferenças encontradas nesta questão são muito numerosas e muito
        grandes. E é por causa desse fato que em nenhuma raça de animais se
        encontraria tanta discórdia, nem se encontraria em nenhuma raça tão
        divergente consigo mesma - tome, por exemplo, cavalos ou cães ou leões
        ou gado ou veados; ao contrário, animais semelhantes se comportam da
        mesma forma na alimentação, na procriação e na criação de seus filhotes,
        e têm os mesmos apetites e as mesmas aversões. A razão é que, em geral,
        eles seguem apenas o que é agradável e evitam o que é doloroso. Mas a
        raça humana, que por natureza participa da sabedoria, embora fique aquém
        dela por causa do mau julgamento e da indiferença, é interiormente cheia
        de opinião e auto-engano. Além disso, os homens diferem uns dos outros
        em tudo - no vestuário e na vestimenta, na comida e nos prazeres
        sexuais, na honra e na desonra - de acordo com as nações e cidades. E da
        mesma forma também com a cidade, cada um tem sua própria ambição
        individual - um para obter tanta terra quanto possível, outro prata,
        outro escravos, outro todas essas coisas juntas, outro para ser admirado
        por sua eloqüência e assim ter maior poder do que seus semelhantes,
        outro se esforça apenas para ser inteligente e adquirir experiência na
        política, outro para ter influência por algum outro motivo, outro para
        se entregar ao luxo ao máximo.
      </p>
      <p className="mt-3 ">
        Agora, como eu estava dizendo, em nenhuma dessas atividades, com toda a
        probabilidade, mesmo aqueles que são considerados os melhores em sua
        linha a levariam a cabo com sucesso. Pois, não sabendo o que é melhor ou
        o que é pior ou o que é vantajoso, eles não exercem nenhuma escolha. Mas
        aquele que desejou sabedoria e pensou em como deveria cuidar de si mesmo
        e que educação deveria receber para se tornar um homem bom e superior às
        massas, ele, eu digo, foi abençoado com um bom caráter e com além disso,
        uma fortuna correspondente. Pois há esperança de que, se ele investigar
        e receber instrução, descobrirá o que é necessário e com que objetivo e
        propósito deve conduzir e regular tudo o mais.
      </p>
      <p className="mt-3 ">
        Mas aquele que compreende isso seria a partir desse momento bem-sucedido
        em todas as coisas, tanto nas que são consideradas mais importantes
        quanto nas que são consideradas menos; e quer ele acompanhe as corridas
        de cavalos ou se dedique à música ou à agricultura, ou se ele desejar
        ser um general ou ocupar os outros cargos ou conduzir os outros negócios
        públicos em sua cidade, ele fará tudo bem. e não cometeria erros em
        nada. No entanto, sem esse entendimento, enquanto em cada um de seus
        trabalhos ele pode às vezes parecer bem-sucedido tanto para si mesmo
        quanto para seus vizinhos - por exemplo, se como agricultor ele fosse
        feliz com suas colheitas, ou se ele tivesse mais do que o conhecimento
        comum com o manejo de cavalos, ou se ele tivesse um conhecimento
        razoavelmente bom de música, ou se em competições atléticas ele pudesse
        superar seus competidores - ainda assim, no geral, ele falharia, já que
        estaria trabalhando nessas coisas para nenhum fim bom nem de modo a
        obter benefícios.{" "}
      </p>
      <p className="mt-3 ">
        Portanto, ele é incapaz de prosperar, assim como alguém não pode fazer
        uma viagem bem-sucedida se não sabe para onde está navegando, sendo
        levado ao acaso no mar, com seu navio navegando em linha reta em um
        momento, caso a sorte assim o determine, mas no próximo momento
        oscilando, em um momento com o vento a favor, no próximo contra o vento.
        Na verdade, assim como com a lira, os músicos primeiro ajustam a corda
        do meio e depois afinam as outras para harmonizar com ela - caso
        contrário, nunca conseguirão qualquer harmonia - assim também na vida,
        os homens devem primeiro compreender o que é melhor e, tendo feito disso
        seu objetivo, devem fazer tudo o mais em referência a isso; caso
        contrário, sua vida estará fora de harmonia e desafinada, muito
        provavelmente.
      </p>
    </div>
  );
};

export default DionSixtyEighth;
